import {
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PSCLogo from "../../Assets/Logo/PSCLogo.jpg";
import { OnlyDateTimeConverter } from "../../Components/Helpers/DateTimeConverter";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../Components/MaterialTableStyle/MaterialTableStyle";
import { useParams } from "react-router-dom";
import { PostMethod } from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader"
import { GreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
const CBTResult = ({
  year,
}) => {
  const params = useParams();
  const [qus_data, setqus_data] = useState([]);
  const [Row1, setRow1] = useState(25);
  const [Row2, setRow2] = useState(50);
  const [Row3, setRow3] = useState(75);
  const [ShowLoader, setShowLoader] = useState(false);
  const [applicationDetail, setapplicationDetail] = useState();
  const [Locations, setLocations] = useState("");
  const [ApplicationBasicDetails, setApplicationBasicDetails] = useState();
  useEffect(() => {
    if (ApplicationBasicDetails?.qus_data) {
      setqus_data(ApplicationBasicDetails.qus_data);
      if (ApplicationBasicDetails.qus_data?.length > 0) {
        let length = ApplicationBasicDetails.qus_data?.length;
     
        let values = Math.round(length / 3);
        let row_1 = values;
        let row_2 = row_1 + values;
        let row_3 = row_2 + values;
        setRow1(row_1);
        setRow2(row_2);
        setRow3(row_3);
      }
    }
  }, [ApplicationBasicDetails]);
  useEffect(()=>{
    if (params?.id) {
      GetApplicationDetails(params.id);
    }
  },[])
  const GetApplicationDetails = async (id) => {
    try {
      let url = "test/viewapplications";
      let method = "POST";
      let params = {
        job_application_uuid: id,
      };
      setShowLoader(true)
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        if (response?.jobapplication[0]) {
          setapplicationDetail(response.jobapplication[0]);
          setApplicationBasicDetails(response.computertest[0])
          setLocations(response.jobapplication[0].computer_locations[0].value)
        }
        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    } catch (Error) {
      setShowLoader(false)
      console.log("Error", Error);
    }
  };

  const handlePrint = () => {
    // Find and hide the button
    const buttonToHide = document.querySelector(".hide-on-print");
    if (buttonToHide) buttonToHide.style.display = "none";

    // Print the content
    window.print();

    // Restore the button after printing
    if (buttonToHide) buttonToHide.style.display = "block";
  };

  return (
    <Grid item  lg={12} md={12} sm={12} xs={12} className="px-3">
      <Grid
        item
        lg={12}
        sm={12}
        md={12}
        xs={12}
        container
        className=""
        border={"1px solid #666666"}
      >
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-3"
          borderBottom={"1px solid #666666"}
        >
          <Grid
            item
            lg={2}
            sm={4}
            md={4}
            xs={4}
            container
            justifyContent={"center"}
          >
            <img
              src={PSCLogo}
              alt="PSCLogo"
              height={80}
              width={80}
              className="img_fluid"
            />
          </Grid>
          <Grid
            item
            lg={10}
            sm={8}
            md={8}
            xs={8}
            container
            alignItems={"center"}
            flexDirection={"column"}
          >
            <h4 className="poppinsSemiBold Text-Prime-Black my-1">
              Police Service Commission
            </h4>
            <p className="poppinsRegular Text-Prime-Gray">
              {Locations? Locations:"---"}
            </p>
            <p className="poppinsRegular Text-Prime-Gray">
              Website: https://psc.gov.ng/
            </p>
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          className="p-2"
          container
          justifyContent={"center"}
          borderBottom={"1px solid #666666"}
        >
          <p className="poppinsSemiBold text-black text-center">
            {" "}
            {applicationDetail?.job_name} for the  year {year}
            {/* {applicationDetail?.job_post} for the */}
            {/* {applicationDetail?.job_post} for the year {year} */}
          </p>
        </Grid>
      </Grid>
      <Grid item lg={12} sm={12} md={12} xs={12} container className="">
        <Grid
          item
          lg={3}
          sm={3}
          md={3}
          xs={3}
          container
          className="p-2"
          alignItems={"center"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            className="py-2"
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsMedium Text-Prime-Black text-left">
                Registration Number
              </p>
            </Grid>
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {applicationDetail?.application_serial}
              </p>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          lg={3}
          sm={3}
          md={3}
          xs={3}
          container
          className="p-2"
          alignItems={"center"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            className="py-2"
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsMedium Text-Prime-Black text-left">
                Total Marks Obtained
              </p>
            </Grid>
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {ApplicationBasicDetails?.total_mark} out of{" "}
                {ApplicationBasicDetails?.allquestions_mark}
              </p>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          lg={3}
          sm={3}
          md={3}
          xs={3}
          container
          className="p-2"
          alignItems={"center"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            className="py-2"
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsMedium Text-Prime-Black text-left">
                Test Date
              </p>
            </Grid>
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {ApplicationBasicDetails?.computer_test_updated_on
                  ? OnlyDateTimeConverter(Number(ApplicationBasicDetails?.computer_test_updated_on) )
                  : "---"}
              </p>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          lg={3}
          sm={3}
          md={3}
          xs={3}
          container
          className="p-2"
          alignItems={"center"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            className="py-2"
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsMedium Text-Prime-Black text-left">
                Result Published on
              </p>
            </Grid>
            <Grid item lg={6} sm={6} md={6} xs={6}>
              <p className="poppinsRegular Text-Prime-Black text-left">
                {ApplicationBasicDetails?.computer_test_updated_on
                  ? OnlyDateTimeConverter(  Number(ApplicationBasicDetails.computer_test_updated_on)   )
                  : "---"}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        lg={12}
        sm={12}
        md={12}
        xs={12}
        container
        style={{ borderBottom: "2px dotted black" }}
      />
      <Grid
        item
        lg={12}
        sm={12}
        md={12}
        xs={12}
        container
        className=""
        justifyContent={"space-between"}
        alignItems={"baseline"}
      >
        <Grid
          item
          lg={3.5}
          sm={3.5}
          md={3.5}
          xs={3.5}
          container
          className="p-2"
          alignItems={"center"}
        >
          <TableContainer className="mt-3">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Q.No
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Answer
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Response
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {qus_data?.slice(0, Row1).map((item, key) => {
                  return (
                    <StyledTableRow key={key}>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {key + 1}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {item.answer == item.optionA
                          ? "A"
                          : item.answer == item.optionB ? "B" : item.answer == item.optionC ? "C"  : "D"}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {item.selectedOption == item.optionA
                          ? "A"
                          : item.selectedOption == item.optionB  ? "B"  : item.selectedOption == item.optionC  ? "C"   : "D"}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          lg={3.5}
          sm={3.5}
          md={3.5}
          xs={3.5}
          container
          className="p-2"
          alignItems={"center"}
        >
          <TableContainer className="mt-3">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Q.No
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Answer
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Response
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {qus_data?.slice(Row1, Row2).map((item, key) => {
                  return (
                    <StyledTableRow key={key}>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {key + Row1 + 1}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {item.answer == item.optionA
                          ? "A"
                          : item.answer == item.optionB ? "B"  : item.answer == item.optionC ? "C" : "D"}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {item.selectedOption == item.optionA
                          ? "A"
                          : item.selectedOption == item.optionB  ? "B" : item.selectedOption == item.optionC ? "C" : "D"}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          lg={3.5}
          sm={3.5}
          md={3.5}
          xs={3.5}
          container
          className="p-2"
          alignItems={"center"}
        >
          <TableContainer className="mt-3">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Q.No
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Answer
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: "12px", border: "1px solid #666666" }}
                    align="center"
                  >
                    Response
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {qus_data?.slice(Row2, Row3).map((item, key) => {
                  return (
                    <StyledTableRow key={key}>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {key + Row2 + 1}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {item.answer == item.optionA
                          ? "A"
                          : item.answer == item.optionB   ? "B"  : item.answer == item.optionC   ? "C"   : "D"}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          fontSize: "12px",
                          border: "1px solid #666666",
                          backgroundColor:
                            item.selectedOption == item.answer
                              ? "#E9F5EA"
                              : "#FCE9ED",
                        }}
                        align="center"
                      >
                        {item.selectedOption == item.optionA
                          ? "A"
                          : item.selectedOption == item.optionB  ? "B"  : item.selectedOption == item.optionC ? "C" : "D"}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Grid item lg={12}    sm={12}  md={12} xs={12} container className="p-3"justifyContent={"center"} >
        <Grid item lg={3}  sm={3} md={3} xs={3} container flexDirection={"column"} alignItems={"center"} >
          <GreenColorButton type="submit"  className="hide-on-print px-3 py-2 ml-3" onClick={() => handlePrint()} >
            print
          </GreenColorButton>
        </Grid>
      </Grid>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
    </Grid>
  );
};

export default CBTResult;
